
// Animation module
import { gsap } from "gsap";
const ScrollTrigger = require('gsap/dist/ScrollTrigger').ScrollTrigger
const ScrollTo = require('gsap/dist/ScrollToPlugin').ScrollToPlugin

if (typeof window !== undefined) {
  gsap.registerPlugin(ScrollTrigger)
  gsap.registerPlugin(ScrollTo)
}

export default gsap